import { render, staticRenderFns } from "./index2024.vue?vue&type=template&id=1aa6bd3a&scoped=true&"
import script from "./index2024.vue?vue&type=script&lang=js&"
export * from "./index2024.vue?vue&type=script&lang=js&"
import style0 from "./index2024.vue?vue&type=style&index=0&id=1aa6bd3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa6bd3a",
  null
  
)

export default component.exports